export default "__VITE_ASSET__CFPgfc5J__"